import { Injectable, Signal, signal } from "@angular/core";
import { IType } from "@geolib/geoappbase-client";
import GeobusNavigationExtension from "./geobus-navigation.extension";


@Injectable({ providedIn: "root" })
export default class GeobusOrganisationExtension extends GeobusNavigationExtension {

    public get component(): IType<unknown> | null {
        return null;
    }

    public get identifier(): string | null {
        return "GeobusOrganisationExtensionName";
    }

    public get title(): Signal<string> {
        return signal("SIDE_MENU.USER_ORGANISATION.ORGANISATION").asReadonly();
    }

    public get category(): string {
        return "user_and_organisation";
    }

    public get state(): { name: string } {
        return { name: "app.organisations" };
    }

    public get icon(): string {
        return "users";
    }

}
